module.exports = __webpack_public_path__ + "img/Weapon_59.2a25ac5e.png";